export const haversineMeters = (a, b) => {
  const R = 6371000;
  const toRad = (d) => (d * Math.PI) / 180;

  const dLat = toRad(b.lat() - a.lat());
  const dLng = toRad(b.lng() - a.lng());

  const lat1 = toRad(a.lat());
  const lat2 = toRad(b.lat());

  const s =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(lat1) * Math.cos(lat2) * Math.sin(dLng / 2) ** 2;

  return 2 * R * Math.asin(Math.sqrt(s));
};

export const clearPoiMarkers = (poiMarkersRef) => {
  poiMarkersRef.current.forEach((m) => m.setMap(null));
  poiMarkersRef.current = [];
};
